var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ml-2 new-badge",attrs:{"x-small":"","color":"success"}},[_vm._v(" NEW ")])
}
var staticRenderFns = []

export { render, staticRenderFns }